
    import Vue from "vue";

    const END_POINT = "/inventory-lab-result";

    const getInventoryLabResult = id => Vue.axios.get(END_POINT + "/" + id);

    const getAllInventoryLabResults = data => Vue.axios.get(END_POINT, {params: data});

    const createInventoryLabResult = inventoryLabResult => Vue.axios.post(END_POINT,  inventoryLabResult );

    const createAllInventoryLabResults = inventoryLabResults => Vue.axios.post(END_POINT + "/all",  inventoryLabResults );

    const parseLabResultPdf = file => {
      const form = new FormData();
      form.append("file", file);
      return Vue.axios.post(END_POINT + "/parse-pdf", form, {
        headers: { "Content-Type": "multipart/form-data" }
      });
    };

    // Retry inventory matching for still-unassigned results tested in the date range.
    const autoAssignInventoryLabResults = params => Vue.axios.post(END_POINT + "/auto-assign", null, { params });

    const updateInventoryLabResult = inventoryLabResult => Vue.axios.put(END_POINT  + "/" + inventoryLabResult.id,  inventoryLabResult );

    const deleteInventoryLabResult = id => Vue.axios.delete(END_POINT  + "/" + id);

    export {
      getInventoryLabResult,
      getAllInventoryLabResults,
      createInventoryLabResult,
      createAllInventoryLabResults,
      updateInventoryLabResult,
      deleteInventoryLabResult,
      parseLabResultPdf,
      autoAssignInventoryLabResults
    };
    